import { useEffect, useState } from "react";
import api from "../../../../../services/api";
import HeaderSession from "../../../../../utils/headerSession";
import Loading from "../../../../../load/loading";
import SearshEstabelecimento from "../../../../../utils/searchEstabelecimento";
import FerramentaNavegacaoExportacao from "../../../../../utils/paginacao";
import ListaSolicitacao from "../listaSolicitacao";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import RegisterAccess from "../../../../../utils/registerAccess";
import { SolicitacoesLicenciamentoExcel } from "../../../../exports/gerarelatorioexcel";
import { SolicitacaoLicenciamentoPdf } from "../../../../exports/gerarelatoriopdf";
import { temPermissao } from "../../../../../utils/permissoes";

export default function ChefedaseccaoArea() {
  const navigate = useNavigate();
  const user = useSelector((state) => state.account.user);
  const dispatch = useDispatch();
  const [tipo, setTipo] = useState("");
  const [status, setStatus] = useState("");
  const [provincia, setProvincia] = useState("");
  const [estabelecimentos, setEstabelecimentos] = useState("");
  const [perPage, setPerPage] = useState(50);
  const [order, setOrder] = useState("");
  const [loading, setLoading] = useState(false);
  const [configLista, setConfigLista] = useState("");
  const [searchParams] = useSearchParams();
  const [page, setPage] = useState(searchParams.get("page"));

  useEffect(() => {
    if (
      (user?.funcao === "Chefe de Secção" ||
        user?.funcao === "Chefe de Departamento" ||
        user?.funcao === "Director Geral" ||
        user?.funcao === "CNP") || temPermissao(user, ['licenciamentoEstabelecimentoChefeSeccao'])
    ) {
    } else {
      dispatch({
        type: "alert",
        payload: { alert: "Acesso negado" },
      });
      navigate("/admin/menu");
    }

    setLoading(true);
    setEstabelecimentos("");
    api
      .get(
        `/estabelecimentos?page=${page}&status=Analisado&perPage=${perPage}&tipoId=${tipo}&status=${status}&provincia=${provincia}&sortBy=nome:${order}`
      )
      .then((response) => {
        setConfigLista(response.data);
        setEstabelecimentos((prevItems) => [
          ...prevItems,
          ...response.data.estabelecimentos,
        ]);

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [
    page, perPage, order, tipo, status, provincia, dispatch, user?.funcao, navigate,
  ]);

  return (
    <>
      <RegisterAccess page={"area de chefe de secção"} />

      <HeaderSession
        title="PROCESSOS ANÁLIZADOS POR TECNICOS"
        actions={true}
        handleExportExcel={() =>
          SolicitacoesLicenciamentoExcel(estabelecimentos)
        }
        handleExportPDF={() => SolicitacaoLicenciamentoPdf(estabelecimentos)}
      />

      <SearshEstabelecimento
        setEstabelecimentos={setEstabelecimentos}
        setTipo={setTipo}
        setStatus={setStatus}
        setProvincia={setProvincia}
        placeholder={"Filtra por nome, número de entrada, data"}
        filtroStatus={false}
        tipo={tipo}
        provincia={provincia}
      />

      {estabelecimentos && (
        <>
          <ListaSolicitacao estabelecimentos={estabelecimentos} >
            <FerramentaNavegacaoExportacao
              configLista={configLista}
              lista={estabelecimentos}
              page={page}
              setPage={setPage}
              setPerPage={setPerPage}
              setOrder={setOrder}
            />
          </ListaSolicitacao>
        </>
      )}

      {loading && <Loading />}
    </>
  );
}
